import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon, { createFromIconfontCN } from '@ant-design/icons';
import { isImg, isUrl, useMountMergeState } from '@ant-design/pro-utils';
import { Menu, Skeleton } from 'antd';
import classNames from 'classnames';
import { useContext, useEffect, useMemo, useRef } from 'react';
import { ProLayoutContext } from '../../context/ProLayoutContext';
import { defaultSettings } from '../../defaultSettings';
import { getOpenKeysFromMenuData } from '../../utils/utils';
import { MenuCounter } from './Counter';
import { useStyle } from './style/menu';
var IconFont = createFromIconfontCN({
  scriptUrl: defaultSettings.iconfontUrl
}); // Allow menu.js config icon as string or ReactNode
//   icon: 'setting',
//   icon: 'icon-geren' #For Iconfont ,
//   icon: 'http://demo.com/icon.png',
//   icon: '/favicon.png',
//   icon: <Icon type="setting" />,

var getIcon = function getIcon(icon) {
  var iconPrefixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon-';
  var className = arguments.length > 2 ? arguments[2] : undefined;

  if (typeof icon === 'string' && icon !== '') {
    if (isUrl(icon) || isImg(icon)) {
      return _jsx(Icon, {
        component: function component() {
          return _jsx("img", {
            src: icon,
            alt: "icon",
            className: className
          });
        }
      });
    }

    if (icon.startsWith(iconPrefixes)) {
      return _jsx(IconFont, {
        type: icon
      });
    }
  }

  return icon;
};

var getMenuTitleSymbol = function getMenuTitleSymbol(title) {
  if (title && typeof title === 'string') {
    var symbol = title.substring(0, 1).toUpperCase();
    return symbol;
  }

  return null;
};

var MenuUtil = /*#__PURE__*/_createClass(function MenuUtil(props) {
  var _this = this;

  _classCallCheck(this, MenuUtil);

  this.props = void 0;

  this.getNavMenuItems = function () {
    var menusData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var level = arguments.length > 1 ? arguments[1] : undefined;
    return menusData.map(function (item) {
      return _this.getSubMenuOrItem(item, level);
    }).filter(function (item) {
      return item;
    }).flat(1);
  };

  this.getSubMenuOrItem = function (item, level) {
    var _this$props = _this.props,
        subMenuItemRender = _this$props.subMenuItemRender,
        baseClassName = _this$props.baseClassName,
        prefixCls = _this$props.prefixCls,
        collapsed = _this$props.collapsed,
        menu = _this$props.menu,
        iconPrefixes = _this$props.iconPrefixes,
        layout = _this$props.layout;
    var isGroup = (menu === null || menu === void 0 ? void 0 : menu.type) === 'group' && layout !== 'top';
    var designToken = _this.props.token;

    var name = _this.getIntlName(item);

    var children = (item === null || item === void 0 ? void 0 : item.children) || (item === null || item === void 0 ? void 0 : item.routes);
    var menuType = isGroup && level === 0 ? 'group' : undefined;

    if (Array.isArray(children) && children.length > 0) {
      var _this$props2, _this$props3, _classNames, _this$props4, _this$props5, _designToken$sider;

      /** Menu 第一级可以有icon，或者 isGroup 时第二级别也要有 */
      var shouldHasIcon = level === 0 || isGroup && level === 1; //  get defaultTitle by menuItemRender

      var iconDom = getIcon(item.icon, iconPrefixes, "".concat(baseClassName, "-icon ").concat((_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.hashId));
      /**
       * 如果没有icon在收起的时候用首字母代替
       */

      var defaultIcon = collapsed && shouldHasIcon ? getMenuTitleSymbol(name) : null;

      var defaultTitle = _jsxs("div", {
        title: name,
        className: classNames("".concat(baseClassName, "-item-title"), (_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "-item-title-collapsed"), collapsed), _defineProperty(_classNames, "".concat(baseClassName, "-item-collapsed-show-title"), (menu === null || menu === void 0 ? void 0 : menu.collapsedShowTitle) && collapsed), _classNames)),
        children: [menuType === 'group' && collapsed ? null : shouldHasIcon && iconDom ? _jsx("span", {
          className: "anticon ".concat(baseClassName, "-item-icon ").concat((_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.hashId),
          children: iconDom
        }) : defaultIcon, _jsx("span", {
          className: classNames("".concat(baseClassName, "-item-text"), (_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.hashId, _defineProperty({}, "".concat(baseClassName, "-item-text-has-icon"), menuType !== 'group' && shouldHasIcon && (iconDom || defaultIcon))),
          children: name
        })]
      }); // subMenu only title render


      var title = subMenuItemRender ? subMenuItemRender(_objectSpread(_objectSpread({}, item), {}, {
        isUrl: false
      }), defaultTitle, _this.props) : defaultTitle;

      var childrenList = _this.getNavMenuItems(children, level + 1);

      if (isGroup && level === 0 && _this.props.collapsed && !menu.collapsedShowGroupTitle) {
        return childrenList;
      }

      return [{
        type: menuType,
        key: item.key || item.path,
        title: item.tooltip || title,
        label: title,
        onClick: isGroup ? undefined : item.onTitleClick,
        children: childrenList,
        className: menuType == 'group' ? "".concat(baseClassName, "-group") : "".concat(baseClassName, "-submenu")
      }, isGroup && level === 0 ? {
        type: 'divider',
        prefixCls: prefixCls,
        className: "".concat(baseClassName, "-divider"),
        key: (item.key || item.path) + '-group-divider',
        style: {
          padding: 0,
          borderBlockEnd: 0,
          margin: _this.props.collapsed ? '4px' : '6px 16px',
          marginBlockStart: _this.props.collapsed ? 4 : 8,
          borderColor: designToken === null || designToken === void 0 ? void 0 : (_designToken$sider = designToken.sider) === null || _designToken$sider === void 0 ? void 0 : _designToken$sider.colorMenuItemDivider
        }
      } : undefined].filter(Boolean);
    }

    return {
      className: "".concat(baseClassName, "-menu-item"),
      title: item.tooltip || name,
      disabled: item.disabled,
      key: item.key || item.path,
      onClick: item.onTitleClick,
      label: _this.getMenuItemPath(item, level)
    };
  };

  this.getIntlName = function (item) {
    var name = item.name,
        locale = item.locale;
    var _this$props6 = _this.props,
        menu = _this$props6.menu,
        formatMessage = _this$props6.formatMessage;

    if (locale && (menu === null || menu === void 0 ? void 0 : menu.locale) !== false) {
      return formatMessage === null || formatMessage === void 0 ? void 0 : formatMessage({
        id: locale,
        defaultMessage: name
      });
    }

    return name;
  };

  this.getMenuItemPath = function (item, level) {
    var _this$props9, _this$props10, _classNames3, _this$props11, _this$props12;

    var itemPath = _this.conversionPath(item.path || '/');

    var _this$props7 = _this.props,
        _this$props7$location = _this$props7.location,
        location = _this$props7$location === void 0 ? {
      pathname: '/'
    } : _this$props7$location,
        isMobile = _this$props7.isMobile,
        onCollapse = _this$props7.onCollapse,
        menuItemRender = _this$props7.menuItemRender,
        iconPrefixes = _this$props7.iconPrefixes; // if local is true formatMessage all name。

    var name = _this.getIntlName(item);

    var _this$props8 = _this.props,
        baseClassName = _this$props8.baseClassName,
        menu = _this$props8.menu,
        collapsed = _this$props8.collapsed;
    var isGroup = (menu === null || menu === void 0 ? void 0 : menu.type) === 'group';
    /** Menu 第一级可以有icon，或者 isGroup 时第二级别也要有 */

    var hasIcon = level === 0 || isGroup && level === 1;
    var icon = !hasIcon ? null : getIcon(item.icon, iconPrefixes, "".concat(baseClassName, "-icon ").concat((_this$props9 = _this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.hashId));
    var defaultIcon = collapsed && hasIcon ? getMenuTitleSymbol(name) : null;

    var defaultItem = _jsxs("div", {
      className: classNames("".concat(baseClassName, "-item-title"), (_this$props10 = _this.props) === null || _this$props10 === void 0 ? void 0 : _this$props10.hashId, (_classNames3 = {}, _defineProperty(_classNames3, "".concat(baseClassName, "-item-title-collapsed"), collapsed), _defineProperty(_classNames3, "".concat(baseClassName, "-item-collapsed-show-title"), (menu === null || menu === void 0 ? void 0 : menu.collapsedShowTitle) && collapsed), _classNames3)),
      children: [icon ? _jsx("span", {
        className: "anticon ".concat(baseClassName, "-item-icon ").concat((_this$props11 = _this.props) === null || _this$props11 === void 0 ? void 0 : _this$props11.hashId),
        children: icon
      }) : defaultIcon, _jsx("span", {
        className: classNames("".concat(baseClassName, "-item-text"), (_this$props12 = _this.props) === null || _this$props12 === void 0 ? void 0 : _this$props12.hashId, _defineProperty({}, "".concat(baseClassName, "-item-text-has-icon"), hasIcon && (icon || defaultIcon))),
        children: name
      })]
    });

    var isHttpUrl = isUrl(itemPath); // Is it a http link

    if (isHttpUrl) {
      var _this$props13, _classNames5, _this$props14, _this$props15;

      defaultItem = _jsxs("span", {
        title: name,
        onClick: function onClick() {
          var _window, _window$open;

          (_window = window) === null || _window === void 0 ? void 0 : (_window$open = _window.open) === null || _window$open === void 0 ? void 0 : _window$open.call(_window, itemPath, '_blank');
        },
        className: classNames("".concat(baseClassName, "-item-title"), (_this$props13 = _this.props) === null || _this$props13 === void 0 ? void 0 : _this$props13.hashId, (_classNames5 = {}, _defineProperty(_classNames5, "".concat(baseClassName, "-item-title-collapsed"), collapsed), _defineProperty(_classNames5, "".concat(baseClassName, "-item-link"), true), _defineProperty(_classNames5, "".concat(baseClassName, "-item-collapsed-show-title"), (menu === null || menu === void 0 ? void 0 : menu.collapsedShowTitle) && collapsed), _classNames5)),
        children: [icon ? _jsx("span", {
          className: "anticon ".concat(baseClassName, "-item-icon ").concat((_this$props14 = _this.props) === null || _this$props14 === void 0 ? void 0 : _this$props14.hashId),
          children: icon
        }) : defaultIcon, _jsx("span", {
          className: classNames("".concat(baseClassName, "-item-text"), (_this$props15 = _this.props) === null || _this$props15 === void 0 ? void 0 : _this$props15.hashId, _defineProperty({}, "".concat(baseClassName, "-item-text-has-icon"), hasIcon && (icon || defaultIcon))),
          children: name
        })]
      });
    }

    if (menuItemRender) {
      var renderItemProps = _objectSpread(_objectSpread({}, item), {}, {
        isUrl: isHttpUrl,
        itemPath: itemPath,
        isMobile: isMobile,
        replace: itemPath === location.pathname,
        onClick: function onClick() {
          return onCollapse && onCollapse(true);
        },
        children: undefined
      });

      return menuItemRender(renderItemProps, defaultItem, _this.props);
    }

    return defaultItem;
  };

  this.conversionPath = function (path) {
    if (path && path.indexOf('http') === 0) {
      return path;
    }

    return "/".concat(path || '').replace(/\/+/g, '/');
  };

  this.props = props;
});
/**
 * 生成openKeys 的对象，因为设置了openKeys 就会变成受控，所以需要一个空对象
 *
 * @param BaseMenuProps
 */


var getOpenKeysProps = function getOpenKeysProps(openKeys, _ref) {
  var layout = _ref.layout,
      collapsed = _ref.collapsed;
  var openKeysProps = {};

  if (openKeys && !collapsed && ['side', 'mix'].includes(layout || 'mix')) {
    openKeysProps = {
      openKeys: openKeys
    };
  }

  return openKeysProps;
};

var BaseMenu = function BaseMenu(props) {
  var _classNames7;

  var mode = props.mode,
      className = props.className,
      handleOpenChange = props.handleOpenChange,
      style = props.style,
      menuData = props.menuData,
      prefixCls = props.prefixCls,
      menu = props.menu,
      matchMenuKeys = props.matchMenuKeys,
      iconfontUrl = props.iconfontUrl,
      propsSelectedKeys = props.selectedKeys,
      onSelect = props.onSelect,
      menuRenderType = props.menuRenderType,
      propsOpenKeys = props.openKeys;
  var designToken = useContext(ProLayoutContext);
  var baseClassName = "".concat(prefixCls, "-base-menu"); // 用于减少 defaultOpenKeys 计算的组件

  var defaultOpenKeysRef = useRef([]);

  var _MenuCounter$useConta = MenuCounter.useContainer(),
      flatMenuKeys = _MenuCounter$useConta.flatMenuKeys;

  var _useMountMergeState = useMountMergeState(menu === null || menu === void 0 ? void 0 : menu.defaultOpenAll),
      _useMountMergeState2 = _slicedToArray(_useMountMergeState, 2),
      defaultOpenAll = _useMountMergeState2[0],
      setDefaultOpenAll = _useMountMergeState2[1];

  var _useMountMergeState3 = useMountMergeState(function () {
    if (menu === null || menu === void 0 ? void 0 : menu.defaultOpenAll) {
      return getOpenKeysFromMenuData(menuData) || [];
    }

    if (propsOpenKeys === false) {
      return false;
    }

    return [];
  }, {
    value: propsOpenKeys === false ? undefined : propsOpenKeys,
    onChange: handleOpenChange
  }),
      _useMountMergeState4 = _slicedToArray(_useMountMergeState3, 2),
      openKeys = _useMountMergeState4[0],
      setOpenKeys = _useMountMergeState4[1];

  var _useMountMergeState5 = useMountMergeState([], {
    value: propsSelectedKeys,
    onChange: onSelect ? function (keys) {
      if (onSelect && keys) {
        onSelect(keys);
      }
    } : undefined
  }),
      _useMountMergeState6 = _slicedToArray(_useMountMergeState5, 2),
      selectedKeys = _useMountMergeState6[0],
      setSelectedKeys = _useMountMergeState6[1];

  useEffect(function () {
    if ((menu === null || menu === void 0 ? void 0 : menu.defaultOpenAll) || propsOpenKeys === false || flatMenuKeys.length) {
      return;
    }

    if (matchMenuKeys) {
      setOpenKeys(matchMenuKeys);
      setSelectedKeys(matchMenuKeys);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [matchMenuKeys.join('-')]);
  useEffect(function () {
    // reset IconFont
    if (iconfontUrl) {
      IconFont = createFromIconfontCN({
        scriptUrl: iconfontUrl
      });
    }
  }, [iconfontUrl]);
  useEffect(function () {
    // if pathname can't match, use the nearest parent's key
    if (matchMenuKeys.join('-') !== (selectedKeys || []).join('-')) {
      setSelectedKeys(matchMenuKeys);
    }

    if (!defaultOpenAll && propsOpenKeys !== false && matchMenuKeys.join('-') !== (openKeys || []).join('-')) {
      var newKeys = matchMenuKeys; // 如果不自动关闭，我需要把 openKeys 放进去

      if ((menu === null || menu === void 0 ? void 0 : menu.autoClose) === false) {
        newKeys = Array.from(new Set([].concat(_toConsumableArray(matchMenuKeys), _toConsumableArray(openKeys || []))));
      }

      setOpenKeys(newKeys);
    } else if ((menu === null || menu === void 0 ? void 0 : menu.ignoreFlatMenu) && defaultOpenAll) {
      // 忽略用户手动折叠过的菜单状态，折叠按钮切换之后也可实现默认展开所有菜单
      setOpenKeys(getOpenKeysFromMenuData(menuData));
    } else if (flatMenuKeys.length > 0) setDefaultOpenAll(false);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [matchMenuKeys.join('-')]);
  var openKeysProps = useMemo(function () {
    return getOpenKeysProps(openKeys, props);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [openKeys && openKeys.join(','), props.layout, props.collapsed]);

  var _useStyle = useStyle(baseClassName),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  var menuUtils = useMemo(function () {
    return new MenuUtil(_objectSpread(_objectSpread({}, props), {}, {
      token: designToken,
      menuRenderType: menuRenderType,
      baseClassName: baseClassName,
      hashId: hashId
    }));
  }, [props, designToken, menuRenderType, baseClassName, hashId]);

  if (menu === null || menu === void 0 ? void 0 : menu.loading) {
    return _jsx("div", {
      style: (mode === null || mode === void 0 ? void 0 : mode.includes('inline')) ? {
        padding: 24
      } : {
        marginBlockStart: 16
      },
      children: _jsx(Skeleton, {
        active: true,
        title: false,
        paragraph: {
          rows: (mode === null || mode === void 0 ? void 0 : mode.includes('inline')) ? 6 : 1
        }
      })
    });
  } // 这次 openKeys === false 的时候的情况，这种情况下帮用户选中一次
  // 第二此不会使用，所以用了 defaultOpenKeys
  // 这里返回 null，是为了让 defaultOpenKeys 生效


  if (props.openKeys === false && !props.handleOpenChange) {
    defaultOpenKeysRef.current = matchMenuKeys;
  }

  var finallyData = props.postMenuData ? props.postMenuData(menuData) : menuData;

  if (finallyData && (finallyData === null || finallyData === void 0 ? void 0 : finallyData.length) < 1) {
    return null;
  }

  return wrapSSR( /*#__PURE__*/_createElement(Menu, _objectSpread(_objectSpread({}, openKeysProps), {}, {
    key: "Menu",
    mode: mode,
    inlineIndent: 16,
    defaultOpenKeys: defaultOpenKeysRef.current,
    theme: "light",
    selectedKeys: selectedKeys,
    style: _objectSpread({
      backgroundColor: 'transparent',
      border: 'none'
    }, style),
    className: classNames(className, hashId, baseClassName, (_classNames7 = {}, _defineProperty(_classNames7, "".concat(baseClassName, "-horizontal"), mode === 'horizontal'), _defineProperty(_classNames7, "".concat(baseClassName, "-collapsed"), props.collapsed), _classNames7)),
    items: menuUtils.getNavMenuItems(finallyData, 0),
    onOpenChange: setOpenKeys
  }, props.menuProps)));
};

export { BaseMenu };